module.exports = "build/assets/RingsideWide-Bold.33b37bef.ttf";